import { Sens } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from './codeProfilEcritures';

export interface GroupeProfilEcriture {
	code: string;
	defaultCodeProfil: (sens?: string) => string;
	isBaseVisible?: boolean;
}

export enum GroupeProfilEcritureCode {
	BASIQUE = 'BASIQUE',
	OPO = 'OPO',
}

export const GROUPE_BASIQUE: GroupeProfilEcriture = {
	code: GroupeProfilEcritureCode.BASIQUE,
	defaultCodeProfil: (sens: string): string =>
		sens === Sens.DEPENSE
			? PROFIL_ECRITURE.DEPENSE.SAI_LIB
			: PROFIL_ECRITURE.RECETTE.SAI_LIB,
};

export const GROUPES_PROFIL_ECRITURE: GroupeProfilEcriture[] = [
	GROUPE_BASIQUE,
	{
		code: GroupeProfilEcritureCode.OPO,
		defaultCodeProfil: (): string => PROFIL_ECRITURE.DEPENSE.OPO_FONC,
		isBaseVisible: true,
	},
] as const;
